import PeerPricingLayerChart from "./PeerPricingLayerChart";
import PeerTowerLayerChart from "./PeerTowerLayerChart";
import { ToggleButton, ToggleButtonGroup, Stack } from "@mui/material";
import Component from "components/Component";
import * as labels from "config.labels";
import { useState } from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const PeerRateChart = () => {
  const [view, setView] = useState("tower");
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const title = translateLabel(labels.PEER_COMPARISON_TOWER_RATE_CHART_TITLE, {
    default: "Rate Per Million vs Layer Midpoint - Peer Comparison",
  });
  const subtitle = translateLabel(
    labels.PEER_COMPARISON_TOWER_RATE_CHART_SUBTITLE,
    {
      default: null,
    }
  );

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  return (
    <Component
      title={title}
      subtitle={subtitle}
      lg_width={12}
      md_width={12}
      options={
        <Stack direction={"row"} alignItems={"center"} spacing={2}>
          <ToggleButtonGroup
            value={view}
            exclusive
            onChange={handleViewChange}
            color={"primary"}
            size={"small"}
            aria-label={"view toggle"}
          >
            <ToggleButton
              value={"tower"}
              aria-label={translateLabel(labels.PEER_RATE_CHART_TOWER_TOOLTIP, {
                default: "Show Tower Layers",
              })}
            >
              {translateLabel(labels.PEER_RATE_CHART_TOWER_BUTTON, {
                default: "Tower",
              })}
            </ToggleButton>
            <ToggleButton
              value={"pricing"}
              aria-label={translateLabel(
                labels.PEER_RATE_CHART_PRICING_TOOLTIP,
                {
                  default: "Show Layers",
                }
              )}
            >
              {translateLabel(labels.PEER_RATE_CHART_PRICING_BUTTON, {
                default: "Layers",
              })}
            </ToggleButton>
          </ToggleButtonGroup>
        </Stack>
      }
    >
      {view === "pricing" ? <PeerPricingLayerChart /> : <PeerTowerLayerChart />}
    </Component>
  );
};

export default PeerRateChart;
